import template from './customer-dropdown.html';
import controller from './customer-dropdown.controller';

let customerDropdownComponent = {
  restrict: 'E',
  bindings: {
    selectedCustomer: '=ngModel',
    onSelect: '&?',
    required: '<?',
    placeholder: '@?',
    disabled: '<?'
  },
  template,
  controller
};

export default customerDropdownComponent;




// WEBPACK FOOTER //
// ./client/common/directives/customer-dropdown/customer-dropdown.component.js